<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M14.8 4.6 19.4 9.2c.8.8.8 2 0 2.8l-7.1 7.1c-.4.4-.9.6-1.4.6H7.5c-.8 0-1.5-.7-1.5-1.5v-3.4c0-.5.2-1 .6-1.4l7.1-7.1c.8-.8 2-.8 2.8 0Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path d="M13 6.4 17.6 11" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    <path d="M6 20.5c1.5 0 2.7-1.2 2.7-2.7V16" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  </svg>
</template>

